module.exports = __webpack_public_path__ + "static/media/fsi.e7025f78.jpg";